export const saveFormDataToLocalStorage = <T>(formDataEntryName: string, formValues: T) => {
    try {
        const serializedData = JSON.stringify(formValues);
        localStorage.setItem(formDataEntryName, serializedData);
    } catch (err) {
        console.error('Error saving form data to localStorage', err);
    }
};

export const getFormDataFromLocalStorage = <T>(formDataEntryName: string): T | null => {
    try {
        const serializedData = localStorage.getItem(formDataEntryName);
        return serializedData ? JSON.parse(serializedData) : null;
    } catch (err) {
        console.error('Error retrieving form data from localStorage', err);
        return null;
    }
};

export const clearFormDataFromLocalStorage = (formDataEntryName: string, formFileEntryName: string) => {
    try {
        localStorage.removeItem(formDataEntryName);
        localStorage.removeItem(formFileEntryName);
    } catch (err) {
        console.error('Error clearing form data from localStorage', err);
    }
};
